import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ConfiguratorGetDataObjectAssignmentsQueryVariables = Types.Exact<{
  filter: Types.DataObjectAssignmentFilterInput;
  take?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ConfiguratorGetDataObjectAssignmentsQuery = { __typename: 'Query', configuratorDataObjectAssignments: Array<{ __typename: 'ConfiguratorArAssignment', id: string, dataObject: { __typename: 'ConfiguratorArAssignmentDataObject', id: string, related: Array<{ __typename: 'ConfiguratorArRelatedDataObject', id: string }> } }> };

export type DeleteDataObjectForActionsMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteDataObjectForActionsMutation = { __typename: 'Mutation', deleteDataObject?: any | null };

export const ConfiguratorGetDataObjectAssignmentsDocument = gql`
    query configuratorGetDataObjectAssignments($filter: DataObjectAssignmentFilterInput!, $take: Int, $skip: Int) {
  configuratorDataObjectAssignments(filter: $filter, take: $take, skip: $skip) {
    id
    dataObject {
      id
      related {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorGetDataObjectAssignmentsGQL extends Apollo.Query<ConfiguratorGetDataObjectAssignmentsQuery, ConfiguratorGetDataObjectAssignmentsQueryVariables> {
    override document = ConfiguratorGetDataObjectAssignmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDataObjectForActionsDocument = gql`
    mutation deleteDataObjectForActions($id: ID!) {
  deleteDataObject(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDataObjectForActionsGQL extends Apollo.Mutation<DeleteDataObjectForActionsMutation, DeleteDataObjectForActionsMutationVariables> {
    override document = DeleteDataObjectForActionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }